var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "400.945 277.64 40 40",
    enableBackground: "new 400.945 277.64 40 40",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1A73E8",
    d: "M425.175,278.305c-1.33-0.423-2.781-0.665-4.261-0.665c-4.26,0-8.097,1.934-10.665,4.985l6.586,5.528 L425.175,278.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M410.25,282.625c-2.024,2.417-3.263,5.559-3.263,8.942c0,2.628,0.514,4.743,1.39,6.646l8.459-10.061 L410.25,282.625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M420.945,286.25c2.961,0,5.348,2.387,5.348,5.348c0,1.299-0.484,2.507-1.27,3.444 c0,0,4.199-5.015,8.309-9.879c-1.691-3.263-4.623-5.74-8.156-6.858l-8.339,9.849C417.833,287.006,419.283,286.25,420.945,286.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M420.945,296.916c-2.961,0-5.347-2.387-5.347-5.348c0-1.299,0.453-2.507,1.238-3.414l-8.459,10.061 c1.45,3.202,3.867,5.801,6.344,9.033l10.302-12.235C424.027,296.19,422.575,296.916,420.945,296.916"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M424.841,310.631c4.654-7.281,10.061-10.574,10.061-19.033c0-2.326-0.574-4.501-1.57-6.435l-18.61,22.084 c0.786,1.027,1.601,2.205,2.387,3.414c2.84,4.381,2.055,6.979,3.867,6.979C422.788,317.64,422.001,315.012,424.841,310.631"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaps);
export default __webpack_public_path__ + "static/media/logo-maps.eb4c404c7508543d7e7e2468dc36325e.svg";
export { ForwardRef as ReactComponent };